<template>
  <footer id="footer" class="main-color mt-5 text-light text-center p-3">
    <span>{{this.config.copyright}}</span>
  </footer>
</template>
<script>
export default {
  name: 'TraderFooter',
  data () {
    return {}
  }
}
</script>



// WEBPACK FOOTER //
// src/components/TraderFooter.vue